<template>
  <!--
          作者：luoyiming
          时间：2019-10-25
          描述：门店列表
      -->
  <div class="user">
    <!--添加门店-->
    <div class="common-level-rail">
      <el-button
        size="small"
        type="primary"
        icon="el-icon-plus"
        @click="addClick"
        >添加手办</el-button
      >
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table
          size="small"
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column prop="id" label="ID" width="90"></el-table-column>
          <el-table-column label="手办图片" width="100">
            <template slot-scope="scope">
              <img v-img-url="scope.row.save_name" width="30px" height="30px" />
            </template>
          </el-table-column>
          <el-table-column prop="card_name" label="手办标题"></el-table-column>
          <el-table-column
            prop="category_name"
            label="所属分类"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="child_category_name"
            label="所属二级分类"
            width="100"
          ></el-table-column>
          <el-table-column prop="probability" label="概率" width="100">
            <template slot-scope="scope">
              {{ scope.row.probability ? scope.row.probability + "%" : "" }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="card_type" label="手办类型" width="100"></el-table-column> -->
          <el-table-column
            prop="product_name"
            label="商品名称"
          ></el-table-column>
          <el-table-column label="商品规格">
            <template slot-scope="scope">
              <span v-if="!scope.row.product_id"></span>
              <span v-if="scope.row.product_id && !scope.row.spec_sku_id"
                >默认规格</span
              >
              <span v-if="scope.row.spec_sku_id">{{
                scope.row.spec_sku_id
              }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="number" label="抽奖数量" width="100"></el-table-column> -->
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small"
                >编辑</el-button
              >
              <el-button
                @click="deleteClick(scope.row)"
                type="text"
                size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import codeApi from "@/api/code.js";
export default {
  components: {},
  inject: ["reload"],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        user: "",
        region: "",
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      codeApi
        .cardList(Params, true)
        .then((data) => {
          self.loading = false;
          self.tableData = data.msg.list;
          self.totalDataNumber = data.msg.total;
        })
        .catch((error) => {});
    },

    /*打开添加*/
    addClick() {
      this.$router.push("/card/card/add");
    },

    /*打开编辑*/
    editClick(row) {
      let self = this;
      let params = row.id;
      this.$router.push({
        path: "/card/card/edit",
        // name: 'mallList',
        query: {
          id: params,
        },
      });
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          codeApi
            .cardDelete(
              {
                id: row.id,
              },
              true
            )
            .then((data) => {
              self.$message({
                message: "恭喜你，删除成功",
                type: "success",
              });
              self.getTableList();
            })
            .catch((error) => {});
        })
        .catch(() => {});
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/card/card/index.vue